module.exports = __webpack_public_path__ + "static/media/intervencion1.c4a893dc.webp";